import type { Viewport } from 'react-flow-renderer';
import type { Bounds } from 'flow/service/graph';
import { CANVAS_HORIZONTAL_PADDING, REQUIRED_SPACE_FOR_ISLAND_NODES } from 'flow/service/graph';
import type { CanvasRect } from '~/dashboard/views/workflows/store/redux/types';

export function getViewportAtEndOfCanvasX(graphBounds: Bounds, canvasRect: CanvasRect): Viewport {
  const widthOfGraphOutOfCanvas = graphBounds.right - canvasRect.width;
  const x = -(
    CANVAS_HORIZONTAL_PADDING
    + widthOfGraphOutOfCanvas
    + REQUIRED_SPACE_FOR_ISLAND_NODES
    + CANVAS_HORIZONTAL_PADDING
  );


  return {
    x,
    y: canvasRect.y,
    zoom: canvasRect.zoom,
  };
}
